import { SITE_BASE_URL } from "@/lib/constants";
import { cn } from "@/lib/utils";

type Props = {
  slug: string;
  className?: string;
};

const MoreInfoButton = ({ slug, className }: Props) => {
  return (
    <a
      href={`${SITE_BASE_URL}/article/${slug}`}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("text-muted-foreground text-sm hover:underline", className)}
    >
      More Info
    </a>
  );
};

export default MoreInfoButton;
